import React from 'react'
import ReturnHeader from '../../components/returnHeader'
import ProfileViews from '../../components/ProfileViews'
import { admin, logout, pen } from '../../assets'
import { Link } from 'react-router-dom'

const index = () => {
  const content =[
    {
      icon: logout,
      text: 'Logout',
      path: '/language'
    },
    {
      icon: admin,
      text: 'Adminga yozish',
    },

  ]
  
  return (
    <>
    <ReturnHeader name={"IUraimov12"}>
    {content &&
            content.map((item)=>(
              <Link to={item.path}
              // onClick={}
              className="flex hover:bg-slate-100 cursor-pointer h-[26px] sm:h-[30px] justify-start gap-5 items-center	p-1.5	md:p-3"
              >
            <div><img className="w-[12px] h-[12px]" src={item.icon} alt="" /></div>
            <div className="text-[13px] md:text-[16px]">{item.text}</div>
          </Link>
            ))}
    </ReturnHeader>
    <ProfileViews
    Follower={'1k'} 
    Following={'1k'} 
    Lessons={'1k'} 
    profession={'Teacher'} 
    firstBtnLink={'/editprofile'}
    name={'Ibrohim IUraimov'}
    info={"Lorem ipsum"}
    Telegram={'Telegram'}
    // firstBtnLink={''}
    secondBtnLink={'/portfolio'}
    Instagram={'Instagram'}
    Facebook={'Facebook'}
    firstBtn={'Edit profile'}
    secondBtn={'Portfolio'}
    thirdBtn={'Share profile'}
    thirdBtnLink={'/message'}
    />
    </>
  )
}

export default index